import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import EmailGradientSupportIcon from '~/components/Icons/svgs/EmailGradientSupportIcon'
import PhoneGradientSupportIcon from '~/components/Icons/svgs/PhoneGradientSupportIcon'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '331px' }]

export default function Support({ className = '', showAvatar = false }): React.ReactElement {
  const { t } = useTranslation('tutorOnDemand')

  return (
    <div className={`text-black-light ${className}`}>
      <div className="max-w-7xl mx-auto">
        <section className="max-w-3xl mx-auto flex flex-row justify-center">
          <div
            className={`w-full sm:w-[442px] mb-auto rounded p-0.5 bg-gradient-tod-heading ${
              showAvatar ? 'mt-28 z-20 sm:z-0' : ''
            }`}
          >
            <div className="flex flex-col gap-3 justify-center items-center py-6 px-4 bg-white rounded">
              <div className="text-center font-semibold">
                <p>
                  {t('landingPage.support.question')} <br /> {t('landingPage.support.talk')}
                </p>
              </div>
              <div className="font-semibold text-purple">
                <a className="flex gap-1 justify-center items-center" href="tel:+4722150300">
                  <SVGIcon icon={PhoneGradientSupportIcon} size={16} />
                  <span>+47 22 150 300</span>
                </a>
                <a className="flex gap-1 justify-center items-center" href="mailto:learn@houseofmath.com">
                  <SVGIcon icon={EmailGradientSupportIcon} size={16} />
                  <span>learn@houseofmath.com</span>
                </a>
              </div>
              <span className="text-center">
                {t('landingPage.support.opening-hour')}
                <br />
                08:30 - 16:30 CET
              </span>
              <hr className="w-full text-[#F0F1F7]" />
              <span className="text-center mt-2">Bygdøy allé 23, 0262 Oslo</span>
            </div>
          </div>
          {showAvatar && (
            <ResponsiveImage
              alt={t('landingPage.support.question')}
              className="-ml-64 sm:-ml-40 z-10 overflow-hidden"
              height={597}
              imageWidths="331"
              mediaQuery={mediaQuery}
              srcKey="mentor-on-demand/home/support-truc-avatar.png"
              width={331}
            />
          )}
        </section>
      </div>
    </div>
  )
}
